
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as errort8y4W5ETdUwVJGpO9MeoeRvur4W83qDRsTTMtXmZ0igMeta } from "/vercel/path0/wowmall-shop/pages/error.vue?macro=true";
import { default as indexjGNN7HsfZ6xXLhz86ua1uxAXr_N3yY80Q5k500ef5JEMeta } from "/vercel/path0/wowmall-shop/pages/index/index.vue?macro=true";
import { default as indexcavU9L18Bqd5mGLHjCsFb53FHz_pZ_Ta27x7dKW0HpUMeta } from "/vercel/path0/wowmall-shop/pages/index.vue?macro=true";
import { default as index1a9FOXZ1IREUVK15vMJNFWZ_45tzc__45820oFLsC_D0Gh8Meta } from "/vercel/path0/wowmall-shop/pages/[slug]/index.vue?macro=true";
import { default as indexIxY2QCgQuEz9CDYrZH18VZTY_vkGeZtUzxKl3NxMosIMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/faq/index.vue?macro=true";
import { default as indexoSr6VYGMGBDrltHLe8QaYEwAhlJUQPEd65xZQbcLZPwMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/cart/index.vue?macro=true";
import { default as indexD0GUVfO864ht07eEkqB_s_hAW6CRZS77V7UOoM0tSoMMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/event/index.vue?macro=true";
import { default as index2DNP3lB2nFh3rcXmQJSQOQpcJA7hlAaLVXX_45Ybs36GwMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/login/index.vue?macro=true";
import { default as indextW9GWWk_45zeaYjT3DMdH8k2rfeLyX4w9R8CmCeaK6LxIMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/search/index.vue?macro=true";
import { default as indexYkM8cOfVfHG9IaGT6mUDeQEQ76E50qDEBCt_45WnZxgfIMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/signup/index.vue?macro=true";
import { default as _91id_93LDwwX3GVm4fq_45VM4bT5Hgy7lcx2R50C_DX9caHN4fWoMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/category/[id].vue?macro=true";
import { default as indexjEkUopFe3bGV36JHiDfPqQEGzSRNDPYRFllOzxtbSDQMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/notices/index.vue?macro=true";
import { default as _91id_93JYwADIDlTy7zXbs8w4vOqBQEVXlGypA6Hk8lzA_g4_AMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/products/[id].vue?macro=true";
import { default as errorNLwSbPAiTI13Aso3wBjM7NFeZbYC5uNxdVWi9lbIJ4YMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/checkout/error.vue?macro=true";
import { default as indexjQn8ozb0Bd_452a2ttYnwUDInM2_DAM4PYKcgws0cGmbIMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/checkout/index.vue?macro=true";
import { default as index_46generatediF0cbH3quvEJdU_45UYzcFratMVy3A5n_452EmoPQpzqyccMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/index.generated.ts?macro=true";
import { default as add1kBJXtPdbc02PHpcYyGhJxgD2ra1PLzgp_45OJn0OmM5IMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/my/tickets/add.vue?macro=true";
import { default as indexFudBc_45KGFYP0dX1A04ZjsL3o5zJFxGH4W_45v213J5XG8Meta } from "/vercel/path0/wowmall-shop/pages/[slug]/products/index.vue?macro=true";
import { default as indexpunS4bxJXyK1QzVeurYDgciCQ90j6thydQV3g0s6COoMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/my/orders/index.vue?macro=true";
import { default as successDtnbtJeFvPCPw_453eE8lGhvhyhf_45I2XmSfK9E3CyZHswMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/checkout/success.vue?macro=true";
import { default as index_xvl8UhCYp7yd7mejwHxoS5mmcWMxtadv8l1RyiorHYMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/my/address/index.vue?macro=true";
import { default as indexiFpXi0d6sdyhCu6cwSqNCNBVbsE8xMcfEotY30VgX1kMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/my/coupons/index.vue?macro=true";
import { default as index2VkJRJzGwMa4sUCqBETHiEDtR39FWx19_ZuAZslkHFoMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/my/profile/index.vue?macro=true";
import { default as indexkl4HDeU9UuI16cEh0zCF0B4_kXDCSJuRNSxiA_45hXOY8Meta } from "/vercel/path0/wowmall-shop/pages/[slug]/my/reviews/index.vue?macro=true";
import { default as indexz_ANLqY_JNJX_45fg6vtHoGfKrW_45i4i7StHDNEOg_2DJkMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/my/reworks/index.vue?macro=true";
import { default as indexoxqGJE7L_Zo1xmMmq3aaaBbZlQnhuBXdCNZ2H8o9ljAMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/my/tickets/index.vue?macro=true";
import { default as indexxP_45gkwEyLO_45OGI5mAEXhaWOK7c4FiBoEQCKBfzbr3gYMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/my/shipping/index.vue?macro=true";
import { default as _91noticeId_93K1DOQVLsDwrEe_urzVDABcdXlAvtwDJTuep3cR4hJDoMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/notices/[noticeId].vue?macro=true";
import { default as _91orderId_93A76bS9htSkuuvWvYM5G4qF_45QV8jN2AGMvuWhMgk2dZYMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/my/orders/[orderId].vue?macro=true";
import { default as _91policyType_93i3Hb45brHrn430AGkNh3jD4iFVVXGUiZwmoAq8r80DIMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/policy/[policyType].vue?macro=true";
import { default as indexK_pvOb1pp3evlejGEofkCLvxbi0wXJp_cKfX4Ps4W3IMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/board/[boardId]/index.vue?macro=true";
import { default as index_46generatedsYYrcbDZgrpJWUuAvjI05Gms7THozZVhwmf8oizTAzUMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/search/index.generated.ts?macro=true";
import { default as _91id_93_46generated127MLOmznPMZoBNxrdo7rRmFQzPbU5wr_HW7qSS7EocMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/category/[id].generated.ts?macro=true";
import { default as _91id_93_46generated7zYX0JtdhXDvshZNWx0oPkjwKB_45LYOa7d8XA_45BQn_lIMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/products/[id].generated.ts?macro=true";
import { default as _91orderId_93fQdbmJAKvAgmFKaCEh0_45i4XqR6dxr6hGGphVqjiTRBUMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/order/success/[orderId].vue?macro=true";
import { default as index_46generatedtTk8R_JmvITNJ_45FfyU_4559utvS6LETQ1k_UxaC_C4oJAMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/my/orders/index.generated.ts?macro=true";
import { default as _91collectionId_93lhFnhGqpY_rrSqHrA0EIB9BUo_45FYgWBlPzVO1hZ1GF0Meta } from "/vercel/path0/wowmall-shop/pages/[slug]/collection/[collectionId].vue?macro=true";
import { default as checkout_46generateda6vLcmbQJXktzKeqO7DzMIXlxue2bDrsMwgCcxopl5EMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/checkout/checkout.generated.ts?macro=true";
import { default as profile_46generatedc_jdU5172hfQZnwSZck5wO8QaR38XxQVOe2iPRG9xFwMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/my/profile/profile.generated.ts?macro=true";
import { default as indexCu5HsKcVsb2Gi59lCGseEvkO3joVQqH3WQKfX6LW6ukMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/my/tickets/[ticketId]/index.vue?macro=true";
import { default as _91orderId_93_46generatedPV67n3kAQNNsawRABl0pJleszkIRTw3XZT0K2ODNVOEMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/my/orders/[orderId].generated.ts?macro=true";
import { default as order_46generatedj4E2Fi4ZegsHIv2kv_qyqqh6okh94OGF4yl7_Ll9ObMMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/order/success/order.generated.ts?macro=true";
import { default as _91policyType_93_46generatedLyqWbE24XbUnUPnP3OXMsR5Jc5Yr0OqQ4jzp5azBRBwMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/policy/[policyType].generated.ts?macro=true";
import { default as indexQf5inzHeygrq7_45m6tPJnDvBK9EbrMK5G_45Yr6iG6zeOEMeta } from "/vercel/path0/wowmall-shop/pages/[slug]/board/[boardId]/[postId]/index.vue?macro=true";
import { default as _91slug_93NCXhf6U6rMwR1HQr_8NLucmljnclkLuSy8WAXBqOJlcMeta } from "/vercel/path0/wowmall-shop/pages/[slug].vue?macro=true";
export default [
  {
    name: "error",
    path: "/error",
    component: () => import("/vercel/path0/wowmall-shop/pages/error.vue")
  },
  {
    name: indexcavU9L18Bqd5mGLHjCsFb53FHz_pZ_Ta27x7dKW0HpUMeta?.name,
    path: "/",
    meta: indexcavU9L18Bqd5mGLHjCsFb53FHz_pZ_Ta27x7dKW0HpUMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/index.vue"),
    children: [
  {
    name: "index",
    path: "",
    component: () => import("/vercel/path0/wowmall-shop/pages/index/index.vue")
  }
]
  },
  {
    name: _91slug_93NCXhf6U6rMwR1HQr_8NLucmljnclkLuSy8WAXBqOJlcMeta?.name,
    path: "/:slug()",
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug].vue"),
    children: [
  {
    name: "slug",
    path: "",
    meta: index1a9FOXZ1IREUVK15vMJNFWZ_45tzc__45820oFLsC_D0Gh8Meta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/index.vue")
  },
  {
    name: "slug-faq",
    path: "faq",
    meta: indexIxY2QCgQuEz9CDYrZH18VZTY_vkGeZtUzxKl3NxMosIMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/faq/index.vue")
  },
  {
    name: "slug-cart",
    path: "cart",
    meta: indexoSr6VYGMGBDrltHLe8QaYEwAhlJUQPEd65xZQbcLZPwMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/cart/index.vue")
  },
  {
    name: "slug-event",
    path: "event",
    meta: indexD0GUVfO864ht07eEkqB_s_hAW6CRZS77V7UOoM0tSoMMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/event/index.vue")
  },
  {
    name: "slug-login",
    path: "login",
    meta: index2DNP3lB2nFh3rcXmQJSQOQpcJA7hlAaLVXX_45Ybs36GwMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/login/index.vue")
  },
  {
    name: "slug-search",
    path: "search",
    meta: indextW9GWWk_45zeaYjT3DMdH8k2rfeLyX4w9R8CmCeaK6LxIMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/search/index.vue")
  },
  {
    name: "slug-signup",
    path: "signup",
    meta: indexYkM8cOfVfHG9IaGT6mUDeQEQ76E50qDEBCt_45WnZxgfIMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/signup/index.vue")
  },
  {
    name: "slug-category-id",
    path: "category/:id()",
    meta: _91id_93LDwwX3GVm4fq_45VM4bT5Hgy7lcx2R50C_DX9caHN4fWoMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/category/[id].vue")
  },
  {
    name: "slug-notices",
    path: "notices",
    meta: indexjEkUopFe3bGV36JHiDfPqQEGzSRNDPYRFllOzxtbSDQMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/notices/index.vue")
  },
  {
    name: "slug-products-id",
    path: "products/:id()",
    meta: _91id_93JYwADIDlTy7zXbs8w4vOqBQEVXlGypA6Hk8lzA_g4_AMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/products/[id].vue")
  },
  {
    name: "slug-checkout-error",
    path: "checkout/error",
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/checkout/error.vue")
  },
  {
    name: "slug-checkout",
    path: "checkout",
    meta: indexjQn8ozb0Bd_452a2ttYnwUDInM2_DAM4PYKcgws0cGmbIMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/checkout/index.vue")
  },
  {
    name: "slug-index.generated",
    path: "index.generated",
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/index.generated.ts")
  },
  {
    name: "slug-my-tickets-add",
    path: "my/tickets/add",
    meta: add1kBJXtPdbc02PHpcYyGhJxgD2ra1PLzgp_45OJn0OmM5IMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/my/tickets/add.vue")
  },
  {
    name: "slug-products",
    path: "products",
    meta: indexFudBc_45KGFYP0dX1A04ZjsL3o5zJFxGH4W_45v213J5XG8Meta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/products/index.vue")
  },
  {
    name: "slug-my-orders",
    path: "my/orders",
    meta: indexpunS4bxJXyK1QzVeurYDgciCQ90j6thydQV3g0s6COoMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/my/orders/index.vue")
  },
  {
    name: "slug-checkout-success",
    path: "checkout/success",
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/checkout/success.vue")
  },
  {
    name: "slug-my-address",
    path: "my/address",
    meta: index_xvl8UhCYp7yd7mejwHxoS5mmcWMxtadv8l1RyiorHYMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/my/address/index.vue")
  },
  {
    name: "slug-my-coupons",
    path: "my/coupons",
    meta: indexiFpXi0d6sdyhCu6cwSqNCNBVbsE8xMcfEotY30VgX1kMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/my/coupons/index.vue")
  },
  {
    name: "slug-my-profile",
    path: "my/profile",
    meta: index2VkJRJzGwMa4sUCqBETHiEDtR39FWx19_ZuAZslkHFoMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/my/profile/index.vue")
  },
  {
    name: "slug-my-reviews",
    path: "my/reviews",
    meta: indexkl4HDeU9UuI16cEh0zCF0B4_kXDCSJuRNSxiA_45hXOY8Meta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/my/reviews/index.vue")
  },
  {
    name: "slug-my-reworks",
    path: "my/reworks",
    meta: indexz_ANLqY_JNJX_45fg6vtHoGfKrW_45i4i7StHDNEOg_2DJkMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/my/reworks/index.vue")
  },
  {
    name: "slug-my-tickets",
    path: "my/tickets",
    meta: indexoxqGJE7L_Zo1xmMmq3aaaBbZlQnhuBXdCNZ2H8o9ljAMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/my/tickets/index.vue")
  },
  {
    name: "slug-my-shipping",
    path: "my/shipping",
    meta: indexxP_45gkwEyLO_45OGI5mAEXhaWOK7c4FiBoEQCKBfzbr3gYMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/my/shipping/index.vue")
  },
  {
    name: "slug-notices-noticeId",
    path: "notices/:noticeId()",
    meta: _91noticeId_93K1DOQVLsDwrEe_urzVDABcdXlAvtwDJTuep3cR4hJDoMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/notices/[noticeId].vue")
  },
  {
    name: "slug-my-orders-orderId",
    path: "my/orders/:orderId()",
    meta: _91orderId_93A76bS9htSkuuvWvYM5G4qF_45QV8jN2AGMvuWhMgk2dZYMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/my/orders/[orderId].vue")
  },
  {
    name: "slug-policy-policyType",
    path: "policy/:policyType()",
    meta: _91policyType_93i3Hb45brHrn430AGkNh3jD4iFVVXGUiZwmoAq8r80DIMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/policy/[policyType].vue")
  },
  {
    name: "slug-board-boardId",
    path: "board/:boardId()",
    meta: indexK_pvOb1pp3evlejGEofkCLvxbi0wXJp_cKfX4Ps4W3IMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/board/[boardId]/index.vue")
  },
  {
    name: "slug-search-index.generated",
    path: "search/index.generated",
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/search/index.generated.ts")
  },
  {
    name: "slug-category-id.generated",
    path: "category/:id().generated",
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/category/[id].generated.ts")
  },
  {
    name: "slug-products-id.generated",
    path: "products/:id().generated",
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/products/[id].generated.ts")
  },
  {
    name: "slug-order-success-orderId",
    path: "order/success/:orderId()",
    meta: _91orderId_93fQdbmJAKvAgmFKaCEh0_45i4XqR6dxr6hGGphVqjiTRBUMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/order/success/[orderId].vue")
  },
  {
    name: "slug-my-orders-index.generated",
    path: "my/orders/index.generated",
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/my/orders/index.generated.ts")
  },
  {
    name: "slug-collection-collectionId",
    path: "collection/:collectionId()",
    meta: _91collectionId_93lhFnhGqpY_rrSqHrA0EIB9BUo_45FYgWBlPzVO1hZ1GF0Meta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/collection/[collectionId].vue")
  },
  {
    name: "slug-checkout-checkout.generated",
    path: "checkout/checkout.generated",
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/checkout/checkout.generated.ts")
  },
  {
    name: "slug-my-profile-profile.generated",
    path: "my/profile/profile.generated",
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/my/profile/profile.generated.ts")
  },
  {
    name: "slug-my-tickets-ticketId",
    path: "my/tickets/:ticketId()",
    meta: indexCu5HsKcVsb2Gi59lCGseEvkO3joVQqH3WQKfX6LW6ukMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/my/tickets/[ticketId]/index.vue")
  },
  {
    name: "slug-my-orders-orderId.generated",
    path: "my/orders/:orderId().generated",
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/my/orders/[orderId].generated.ts")
  },
  {
    name: "slug-order-success-order.generated",
    path: "order/success/order.generated",
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/order/success/order.generated.ts")
  },
  {
    name: "slug-policy-policyType.generated",
    path: "policy/:policyType().generated",
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/policy/[policyType].generated.ts")
  },
  {
    name: "slug-board-boardId-postId",
    path: "board/:boardId()/:postId()",
    meta: indexQf5inzHeygrq7_45m6tPJnDvBK9EbrMK5G_45Yr6iG6zeOEMeta || {},
    component: () => import("/vercel/path0/wowmall-shop/pages/[slug]/board/[boardId]/[postId]/index.vue")
  }
]
  }
]